angular.module('unica_user.user_services')

.factory('UserDeleteService', function ($http, getBaseApiURL) {

	var userDeleteService = {};

	userDeleteService.delete = function (userId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/user/delete/' + userId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	userDeleteService.restore = function (userId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/restore/' + userId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return userDeleteService;
});